var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M7.5 42q-.65 0-1.075-.425Q6 41.15 6 40.5q0-.65.425-1.075Q6.85 39 7.5 39h3.1V7.5q0-.65.425-1.075Q11.45 6 12.1 6h16.5q.65 0 1.075.425.425.425.425 1.075v.75h5.85q.65 0 1.075.425.425.425.425 1.075V39h3.05q.65 0 1.075.425Q42 39.85 42 40.5q0 .65-.425 1.075Q41.15 42 40.5 42h-4.55q-.65 0-1.075-.425-.425-.425-.425-1.075V11.25H30.1V40.5q0 .65-.425 1.075Q29.25 42 28.6 42Zm6.1-33v30Zm10.95 15q0-.85-.575-1.425Q23.4 22 22.55 22q-.85 0-1.425.575-.575.575-.575 1.425 0 .85.575 1.425Q21.7 26 22.55 26q.85 0 1.425-.575.575-.575.575-1.425ZM13.6 39h13.5V9H13.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomExit);
export default __webpack_public_path__ + "static/media/custom-exit.1480fd3adbc5f25c5b9d9c5ba674cfd1.svg";
export { ForwardRef as ReactComponent };